import React from "react";
import Header8 from "./../Common/Header8";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import Projects6 from "./../Elements/Projects6";

var bnrimg = require("../../images/banner/banner.jpg");

class ProjectDetail1 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }
    loadScript("/assets/js/custom.js")
  }
  render() {
    return (
      <>
        <Header8 />
        <div className="page-content">
          <Banner
            title="Projet Vallée Val d’Or 2"
            pagename="Projet Vallée Val d’Or 2"
            bgimage={bnrimg}
            parent="Nos Projets"
            parentLink="/projets"
          />

          {/* SECTION CONTENT START */}
          <div className="section-full p-tb80 inner-page-padding stick_in_parent">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-md-7  sticky_column">
                  <div className="project-detail-containt">
                    <div className="bg-white text-black">
                      <h3 style={{ fontWeight: "800", color: "#357dab" }}>
                        Projet Vallée Val d’Or 2
                      </h3>
                      <p>
                        {" "}
                        <b>CARACTERISTIQUES DU PROJET</b>
                      </p>
                      <p>
                        Le Projet « VAL D’OR 2 », qui s’étale sur une superficie
                        de 3 hectares environ, est initié par l’association la
                        Vallée en partenariat avec une amicale ayant les mêmes
                        objectifs.
                      </p>
                      <p>
                        La 1ère phase du projet vous offre des appartements
                        d’une superficie allant de 80 à 160 m² et des lots de
                        villas d’une superficie allant de 200 à 400 m², dont le
                        coût est estimé à :
                      </p>
                      <ul className="m-l20">
                        <li>5 500,00 dh / m² pour les lots villas</li>
                        <li>
                          6 500,00 dh/ m² pour les appartements (hors frais
                          Sous-Sol).
                        </li>
                      </ul>
                      <p>Ce projet vous offre également :</p>
                      <ul className="m-l20">
                        <li>
                          Un cadre de vie agréable avec piscines et des espaces
                          verts
                        </li>
                        <li>Un environnement des plus avantageux</li>
                        <li>
                          La Proximité de Rabat, Skhirat, Mohammedia, et
                          Casablanca
                        </li>
                        <li>
                          Un Accès doublement servi par la route côtière et par
                          les échangeurs de l’autoroute (Harhoura et Ain ATIQ)
                        </li>
                        <li>Une Zone Micro-Climat.</li>
                      </ul>
                      <p>
                        <b>CARACTERISTIQUES DU TERRAIN : </b>
                      </p>
                      <ul className="m-l20">
                        <li>
                          Le terrain est titré et s’étale sur une superficie
                          totale de 3 hectares environ;
                        </li>
                        <li>
                          Le terrain se situe à Harhoura à 15mn de Hay Riad
                          Rabat;
                        </li>
                        <li>
                          Le terrain est situé sur une colline plate avec vue
                          panoramique sur la Plage Petit Val d’Or;
                        </li>
                        <li>
                          Le terrain est accessible via la route Côtière
                          Rabat-Casa;
                        </li>
                        <li>
                          Le terrain est dans la zone Harhoura et bénéficiant
                          d’un microclimat;
                        </li>
                      </ul>
                      <p>
                        <b>Modalités de réalisation du projet: </b>
                      </p>
                      <p>
                        <b>Pour la tranche « lot de villa » :</b>
                      </p>
                      <ul className="m-l20">
                        <li>
                          Acquisition du terrain par le biais des cotisations de
                          ses membres.
                        </li>
                        <li>
                          L’association se charge du morcellement du terrain en
                          plusieurs lots titrés.
                        </li>
                        <li>
                          Les adhérents/bénéficiaires, une fois disposant de
                          leur titre individuel peuvent soit :
                        </li>
                        <li>
                          Le délai prévisionnel du projet est de 16 mois pour le
                          lotissement après obtentions des autorisations
                          nécessaires.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 ">
                  <div className="project-detail-outer">
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("../../images/projects/image4.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("../../images/projects/image3.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("../../images/projects/image1.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* SECTION CONTENT END  */}
          <Projects6 />
        </div>
        <Footer />
      </>
    );
  }
}

export default ProjectDetail1;
